import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as api from '../api/fpQaApi';
import type {
  RenameFpQaEngagementPayload,
  ShareFpQaEngagementPayload,
} from '../types/fp-qa.types';

export const fpQaKeys = {
  all: ['fp-qa-engagements'] as const,
  list: () => [...fpQaKeys.all, 'list'] as const,
  detail: (id: string) => [...fpQaKeys.all, 'detail', id] as const,
};

export function useFpQaEngagements() {
  return useQuery({
    queryKey: fpQaKeys.list(),
    queryFn: api.listFpQaEngagements,
    refetchOnWindowFocus: false,
  });
}

export function useFpQaEngagement(id: string | null | undefined) {
  return useQuery({
    queryKey: fpQaKeys.detail(id ?? ''),
    queryFn: () => api.getFpQaEngagement(id as string),
    enabled: Boolean(id),
    refetchOnWindowFocus: false,
  });
}

export function useRenameFpQaEngagement(id: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: RenameFpQaEngagementPayload) =>
      api.renameFpQaEngagement(id, payload),
    onSuccess: (data) => {
      queryClient.setQueryData(fpQaKeys.detail(data.id), data);
      queryClient.invalidateQueries({ queryKey: fpQaKeys.list() });
    },
  });
}

export function useShareFpQaEngagement(id: string) {
  return useMutation({
    mutationFn: (payload: ShareFpQaEngagementPayload) => api.shareFpQaEngagement(id, payload),
  });
}
